module.exports = __webpack_public_path__ + "img/horizontal_7_1_8004.18233cf0.png";